<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :model="queryParams" size="small" :inline="true" label-width="68px">
      <el-form-item label="角色名称" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入角色名称" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"> 搜索 </el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" type="flex" justify="end">
      <el-col :span="1.5">
        <el-button v-permission="['roles_add']" type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
          新增角色
        </el-button>
      </el-col>
    </el-row>

    <el-table style="margin-top: 10px" v-loading="loading" :data="roleList">
      <el-table-column
        v-permission="['roles_edit', 'roles_enable', 'roles_disable']"
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-permission="['roles_edit']"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >
            修改
          </el-button>
          <el-button
            size="mini"
            v-permission="['roles_enable', 'roles_disable']"
            type="text"
            icon="el-icon-delete"
            @click="handleChangeStatus(scope.row)"
          >
            {{ scope.row.enable ? '禁用' : '启用' }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="id">
        <template slot-scope="{ row }">
          <el-tag :type="row.enable ? '' : 'danger'">
            {{ row.enable ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="角色名称" align="center" prop="roleName" />
      <el-table-column label="角色权限" align="center" prop="gender">
        <template slot-scope="{ row }">
          <span>{{ row.menuAuth.map((item) => item.name).join(',') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="角色描述" align="center" prop="roleDesc" show-overflow-tooltip />
      <el-table-column label="创建人/修改人" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.creatorName }}/{{ row.updaterName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间/修改时间" align="center" prop="createTime">
        <template slot-scope="{ row }">
          <span>{{ row.createTime }}/{{ row.updateTime }}</span>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />

    <!-- 添加或修改角色对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="390px" append-to-body :destroy-on-close="true">
      <el-form ref="roleForm" :model="roleForm" :rules="rules" label-width="80px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item v-model="roleForm.menuCodes" prop="menuCodes" label="角色权限">
          <treeselect
            v-model="roleId"
            :multiple="true"
            :limit="2"
            :options="menuOptions"
            :limitText="limitText"
            placeholder="选择权限"
            noChildrenText="无数据"
            :normalizer="normalizer"
            @close="handleCloseTree"
          >
          </treeselect>
          <!-- <select-tree ref="selectTree" :options="menuOptions" :defaultProps="defaultProps" :defaultSelectVal='roleForm.menuAuth || []'></select-tree> -->
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="text" v-model="roleForm.roleDesc" placeholder="" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="buttonLoading" type="primary" @click="submitForm"> 确 定 </el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRoleList, getMenuList, addRole, updateRole, deactivateRole, activateRole } from '@/api/mange/role'
import Pagination from '@/components/Pagination'
import Treeselect from '@riophae/vue-treeselect' // 使用文档：https://vue-treeselect.js.org/
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { flat2treeHelp } from '@/utils/flat2tree'
import { cloneDeep } from 'lodash'

export default {
  name: 'Role',
  components: { Pagination, Treeselect },
  data() {
    var validateMenuCodes = (rule, value, callback) => {
      if (this.roleId.length == 0) {
        callback(new Error('请选择角色权限'))
      } else {
        callback()
      }
    }
    return {
      roleId: [],
      // 按钮loading
      buttonLoading: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        current: 1,
        size: 20,
        name: undefined,
        email: undefined
      },
      currentPwd: '',
      emialDisabled: false,
      // 表单参数
      roleForm: {
        menuCodes: []
      },
      // 表单校验
      rules: {
        roleName: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        menuCodes: [
          {
            required: true,
            message: '请选择权限',
            trigger: 'blur',
            validator: validateMenuCodes
          }
        ]
      },
      normalizer(node) {
        return {
          id: node.code,
          label: node.name,
          children: node.children
        }
      },
      limitText(counnt) {
        return `+${counnt}`
      },
      menuOptions: [],
      options: []
    }
  },
  watch: {
    roleId: function (arr) {
      // let temp = [];
      // this.options.forEach((item) => {
      //   if (arr.includes(item.id)) {
      //     temp.push(item);
      //   }
      // });
      // this.recursiveIDNew(temp);
    }
  },
  created() {
    this.getList()
    this.getMenuOptios()
  },
  methods: {
    /** 查询角色列表 */
    getList() {
      this.loading = true
      getRoleList(this.queryParams).then((response) => {
        this.roleList = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询菜单列表 */
    getMenuOptios() {
      getMenuList(this.queryParams).then((res) => {
        const flatOptions = flat2treeHelp(res.data)
        const optionsObj = {}
        res.data.forEach((item) => {
          if (item.type !== 'ROOTMENU') {
            const parentMenu = res.data.filter((filterItem) => filterItem.id === item.parentMenuId)[0]
            item.parentMenuCode = (parentMenu && parentMenu.code) || ''
            optionsObj[item.code] = item
          }
        })
        flatOptions.forEach((item) => {
          optionsObj[item.code] = item
        })
        this.options = JSON.parse(JSON.stringify(optionsObj))
        this.menuOptions = flatOptions
      })
    },
    handleCloseTree(item) {
      this.roleForm.menuCodes = item
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.roleForm = {
        roleName: '',
        menuCodes: [],
        roleDesc: ''
      }
      this.roleId = []
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '新增角色'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      const rowData = cloneDeep(row)
      const menuCode = this.getSelectedMenu(rowData.menuAuth)
      this.roleForm = rowData
      this.roleForm.menuCodes = menuCode
      this.roleId = menuCode
      this.open = true
      this.title = '修改角色'
    },
    getSelectedMenu(menuAuth) {
      const flatData = flat2treeHelp(menuAuth)
      const fn = (arr, acc = []) => {
        return arr.reduce((last, item) => {
          return [...last, ...(item.children && item.children.length > 0 ? fn(item.children, []) : [item.code])]
        }, acc)
      }
      const selctedMenuCodesArr = fn(flatData)
      return selctedMenuCodesArr
    },
    /* 获取要提交的code
       勾选父级时要把对应的子级也传过去，
       勾选部分时要同时把勾选的子级和父级也给传过去
    */
    getMenuCodes() {
      const { roleForm, options } = this
      const menuCodesSet = new Set()
      // 找出父级
      function getParentCodes(code) {
        let curItem = options[code]
        while (curItem && curItem.parentMenuId !== 0) {
          if (!menuCodesSet.has(curItem.parentMenuCode)) {
            menuCodesSet.add(curItem.parentMenuCode)
          }
          curItem = options[curItem.parentMenuCode]
        }
      }
      function setCodes(data) {
        data.forEach((code) => {
          if (!menuCodesSet.has(code)) {
            menuCodesSet.add(code)
            getParentCodes(code) // 确保父级也被添加
          }
          const curItem = options[code]
          if (curItem && curItem.children) {
            const childrenCodes = curItem.children.map((item) => item.code)
            setCodes(childrenCodes)
          }
        })
      }
      setCodes(roleForm.menuCodes)
      return Array.from(menuCodesSet)
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['roleForm'].validate((valid) => {
        if (valid) {
          const apiFn = this.roleForm.id != null ? updateRole : addRole
          this.buttonLoading = true
          let params = { ...this.roleForm }
          params.menuCodes = this.getMenuCodes()
          apiFn(params)
            .then((response) => {
              this.msgSuccess(this.roleForm.id != null ? '修改成功' : '新增成功')
              this.open = false
              this.getList()
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    /** 禁用。启用操作 */
    handleChangeStatus(row) {
      const ids = row.id || this.id
      const apiFn = row.enable ? deactivateRole : activateRole
      const tip = row.enable ? '请确认是否禁用？禁用后仍关联角色的用户将无权访问任意页面！' : '确认启用该角色吗？'
      this.$confirm(tip)
        .then(() => {
          this.loading = true
          return apiFn(ids)
        })
        .then(() => {
          this.loading = false
          this.msgSuccess('操作成功')
          this.getList()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
      deactivateRole
    }
  }
}
</script>
<style lang="scss" scoped>
// .app-container {
//   overflow-y: auto;
// }
.is-error {
  margin-bottom: 32px;
}
</style>
